module.exports = __webpack_public_path__ + "img/2.95c99782.png";